/**
 * @deprecated Please move your code to the specific domain and use DAO, DTO and model separation
 */
export class MqttUser {
  id: string;
  username: string;
  deviceIds: Array<string>;
  active: boolean;
}
